<template>
    <div class="content">
        <Header :noFaq="true"></Header>
        <div class="security-box">
            <el-menu :default-active="route" router class="menu-box showVertical" mode="vertical">
              <el-menu-item class="menu-item" index="/studyRecordCount"><img class="menu-image" src="@/assets/images/menu-summary.png" /><span slot="title">學生表現<br />Learning Performance</span></el-menu-item>
                <el-menu-item class="menu-item" index="/studentProfile"><img class="menu-image" src="@/assets/images/menu-summary.png" /><span slot="title">學生帳戶<br />Student Account</span></el-menu-item>
                <el-menu-item class="menu-item" index="/parentProfile"><img class="menu-image" src="@/assets/images/menu-account.png" /><span slot="title">家長資料<br />Parent Info.</span></el-menu-item>
                <el-menu-item class="menu-item" index="/purchaseHistory"><img class="menu-image" src="@/assets/images/menu-purchase.png" /><span slot="title">訂閱付費紀錄<br />Subscribe Record</span></el-menu-item>
            </el-menu>
            <!-- <el-menu :default-active="route" router class="menu-box showHorizontal" mode="horizontal">
                <el-menu-item class="menu-item" index="/studentProfile"
                    ><img class="menu-image" src="@/assets/images/menu-summary.png" /><span slot="title">學生帳戶及表現<br />Student Account</span></el-menu-item
                >
                <el-menu-item class="menu-item" index="/parentProfile"
                    ><img class="menu-image" src="@/assets/images/menu-account.png" /><span slot="title">家長資料<br />Parent Info.</span></el-menu-item
                >
                <el-menu-item class="menu-item" index="/purchaseHistory"
                    ><img class="menu-image" src="@/assets/images/menu-purchase.png" /><span slot="title">訂閱付費紀錄<br />Subscribe Record</span></el-menu-item
                >
            </el-menu> -->
            <div style="flex: 1; overflow-x: hidden">
                <!-- <keep-alive :include='includes'> -->
                <router-view :detail="detail" @getProfile="getProfile" />
                <!-- </keep-alive> -->
            </div>
        </div>
    </div>
</template>

<script>
import Header from "@/layout/Header";
import { getProfile } from "@/api/user";
import { setUserInfo } from "@/utils/auth";
export default {
    components: { Header },
    data() {
        return {
            route: "/parentProfile",
            detail: {},
        };
    },
    mounted() {
        this.getProfile();
        this.route = this.$route.path;
    },
    destroyed() {},
    watch: {
        "$route.path": {
            handler(v) {
                this.route = v;
            },
            deep: true,
        },
    },
    methods: {
        getProfile() {
            getProfile().then((v) => {
                if (this.userInfo.roleName == this.roleNameParent) {
                    let detail = v.data;
                    detail.students = detail.students.map((student) => {
                        student.subscriptions = student.subscriptions.sort((a, b) => new Date(b.startDate).getTime()-new Date(a.startDate).getTime());
                        return student;
                    });
                    setUserInfo("userProfile", detail);
                    // let now = new Date().getTime();
                    this.detail = detail;
                    this.detail.students.map((item) => {
                        // item.subscriptionIndex = item.subscriptions.findIndex((v) => {
                        //     // return new Date(v.startDate).getTime() < now && new Date(v.endDate).getTime() > now;
                        //     return this.$options.filters["isBetween2"](new Date(),v.startDate,v.endDate)
                        // });
                        item.subscriptionIndex = 0
                        if(item.subscriptions.length>0)this.$set(item, "gradeId", item.subscriptions[item.subscriptionIndex].gradeId);
                        // if (item.subscriptionIndex == -1) item.subscriptionIndex = 0;
                        // // else this.$set(item, "gradeId", item.grade?.id || item.subscriptions[item.subscriptionIndex].gradeId);
                        // else this.$set(item, "gradeId", item.subscriptions[item.subscriptionIndex].gradeId);
                        return item;
                    });
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.showVertical {
    display: block;
}
.showHorizontal {
    display: none;
}
.content {
    width: 100% !important;
}
.security-box {
    display: flex;
    height: calc(100vh - 4.5rem);
}
.menu-box {
    position: -webkit-sticky;
    position: sticky;
    top: 4.5rem;
    left: 0;
    z-index: 1999;
}
.menu-image {
    height: 1.6rem;
    width: auto;
    margin-right: 0.25rem;
    vertical-align: middle;
}
.el-menu-item {
    font-weight: bold;
    font-size: 1rem;
    color: #444444;
    margin: 3rem 1rem;
    padding: 0 1rem !important;
    border-radius: 0.5rem;
    border-bottom: none;
    display: flex;
    align-items: center;
    span {
        white-space: normal;
        word-break: break-all;
        line-height: 1.25;
        flex: 1;
        //padding-right: 20px;
    }
}
.el-menu-item.is-active {
    color: #444444;
    background-color: #f6c98e;
    border-bottom: none;
}
.el-menu--collapse {
    width: 5rem;
}
::v-deep {
    .el-menu--collapse .el-menu-item {
        padding: 0 !important;
        .el-tooltip {
            padding: 0 !important;
        }
    }
}
/*在768 和991 像素之间的屏幕里，小屏幕，主要是PAD*/
@media (min-width: $minWidth) and (max-width: $maxWidth) {
    .el-menu-item {
        margin: 2rem 0.75rem;
        padding: 0 0.75rem !important;
    }
}
@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
    .el-menu-item.is-active {
        background-color: #f6c98e !important;
    }
    .showVertical {
        display: none;
    }
    .showHorizontal {
        display: block;
    }
    /*.content{
      height: 100%;
    }*/
    .security-box {
        height: 100%;
        flex-direction: column;
    }
    .menu-box {
        top: 3.5rem;
    }
    .el-menu-item {
        margin: 0.75rem;
    }
}
</style>
